import { Card, Row, Col, CardDeck } from 'react-bootstrap';
// eslint-disable-next-line no-unused-vars
import verification from 'assets/img/verification.svg';
import './styles.scss';
// eslint-disable-next-line no-unused-vars
import Rating from 'react-rating';
import comilla from 'assets/img/comillas.png';


export default function ReviewDetail({
  name,
  title,
  description,
  date,
  rating,
  variant = 'medium',
  children,
  ...props
}) {
  {/*return (
    <article className={`ReviewDetail--${variant} mb-1`} {...props}>
      {children || (
        <Row>
          <Col md={10} className="px-0 ml-1">
            <div  >
              {/* eslint-disable-next-line jsx-a11y/alt-text
              <img src={comilla} />
            </div>
            <div>
              {description && (
                <div className="descripcion">
                  {description}
                </div>
              )}
              <br></br>
            </div>
            <div className="fondo">
              <Row>
                <Col>
                  <div className={`ReviewDetail__Useravatar ReviewDetail__Useravatar--${variant}`} >
                    <p className="m-0">{name.charAt(0).toUpperCase()}</p>
                    <img
                      className={`ReviewDetail__UserverificationIcon ReviewDetail__UserverificationIcon--${variant}`}
                      src={verification}
                      alt="Avatar"
                    />
                  </div>
                </Col>
                <Col>
                  <div className="m-0 d-flex justify-content-between">
                    <p className="ReviewDetail__Username m-0">{name}</p>
                  </div>
                   <Card.Title className="ReviewDetail__Usertitle">{title}</Card.Title>
                  <Card.Text className="ReviewDetail__Userdate m-0 py-1">{date}</Card.Text>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      )}
    </article>
  );*/}
  return(
      <CardDeck>
        {children || (
        <Card {...props}>
          <Card.Body>
            {/* eslint-disable-next-line jsx-a11y/alt-text */}
            <Card.Title><img src={comilla} /></Card.Title>
            <Card.Text className="text-center">
              {description}
            </Card.Text>
          </Card.Body>
          <Card.Footer className="footercolor">
            <Row>
              <Col xs={3}>
                <div className={`ReviewDetail__Useravatar ReviewDetail__Useravatar--${variant}`} >
                  <p className="m-0">{name.charAt(0).toUpperCase()}</p>
                </div>
              </Col>
              <Col xs={9}>
                <Card.Title><strong>{name}</strong></Card.Title>
                <Card.Text>{title} {date}</Card.Text>
              </Col>
            </Row>
          </Card.Footer>
        </Card>
        )}
      </CardDeck>
  );

}
